import { ADMIN_PATHS, NETWORK_PATHS, PATHS } from "@/routing/paths"

export const getClusterLinkSheet = <TCluster extends { id: string }>(cluster?: TCluster | null) => {
  return `${PATHS.NETWORK}${NETWORK_PATHS.CLUSTERS}/${cluster?.id ?? "0"}`
}

export const getClusterLinkSheetInAdmin = <TCluster extends { id: string }>(
  cluster?: TCluster | null
) => {
  return `${PATHS.ADMIN}${ADMIN_PATHS.CLUSTERS}/${cluster?.id ?? "0"}`
}
